import { customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { DelayedPanicRequestModel } from 'model/mobile-app-dashboard';

@customElement('delayed-panic-request')
export class DelayedPanicRequestCustomElement {
  @bindable
  data: DelayedPanicRequestModel;

  async showPanicRequest() : Promise<void> {
    if (this.data.panicRequest)
      await this.data.showPanicRequest(this.data.panicRequest);
  }
}
